import { useState } from "react";
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'; // Upewnij się, że importujesz auth
import "../css/login.css";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';

export default function Login() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const navigate = useNavigate();

  const openToast = (message) => {
    const Toastify__toast = document.querySelector('.Toastify__toast ');
      if(Toastify__toast === null){
      toast.error(message, {
        position: 'top-center',
      });
    }
  }

  const login = async (e) => {
    e.preventDefault();
    const auth = getAuth(); // Inicjalizuj instancję auth
    try {
      const result = await signInWithEmailAndPassword(auth, email, password); // Użyj nowej metody
  
      // Sprawdzenie ról użytkownika
      if (result.user.displayName === 'superadmin') {
        navigate("/super-admin/pre-alerts-managment");
      } else if (result.user.displayName === 'manager') {
        navigate("/super-admin/pre-alerts-managment");
      } else if (result.user.displayName === 'porter' || result.user.displayName === 'shunter') {
        navigate("/super-admin/parking-map");
      }
    } catch (error) {
      console.error(error); // Wyświetlenie błędu w konsoli
      openToast('Incorrect email or password'); // Użyj toast do wyświetlania błędów
    }
  };

  return (
    <>
    <link
      href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
      rel="stylesheet"
      integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
      crossOrigin="anonymous"
    />
    <ToastContainer style={{ width: '800px' }} autoClose={2000}/>
    <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Sign in</h2>
      </div>
      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form className="space-y-6" onSubmit={login}>
        <div className="mb-3">
            <label htmlFor="formGroupExampleInput2" className="form-label">
            Email
            </label>
            <input
              type="text"
              className="form-control"
              id="formGroupExampleInput2"
              placeholder="office@slampoland.pl"
              name='email'
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
    
          <div className="mb-3">
            <label htmlFor="formGroupExampleInput" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="formGroupExampleInput"
              placeholder='password'
              name='password'
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div>
            <button type='submit' className="flex w-full justify-center rounded-md btn btn-warning px-3 py-1.5 text-sm font-semibold leading-6 shadow-sm" style={{ textTransform: 'none' }}>Sign in</button>
          </div>
        </form>
      </div>
    </div>
    </>
  );
}
